'use client'

import { useState } from 'react'
import type { CartItem } from '@/../types/sale-page'
import { copyCartToClipboard } from './cartCopy'

// "คัดลอกตะกร้า" — copies the cart as a chat message (+ snapshot code) so the
// customer can paste it into the shop's chat and have the bot build the order.
export default function CopyCartButton({
  shopId,
  salePageId,
  items,
  className,
  label = 'คัดลอกตะกร้าไปแชท',
}: {
  shopId: string
  salePageId?: string
  items: CartItem[]
  className?: string
  label?: string
}) {
  const [copied, setCopied] = useState(false)
  const [busy, setBusy] = useState(false)

  const handle = async () => {
    if (busy || items.length === 0) return
    setBusy(true)
    const ok = await copyCartToClipboard(shopId, salePageId, items)
    setBusy(false)
    if (ok) {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  return (
    <button
      type="button"
      onClick={handle}
      disabled={busy || items.length === 0}
      title="คัดลอกรายการในตะกร้าเพื่อวางในแชทร้าน"
      className={
        className ??
        'inline-flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-3 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50 disabled:opacity-50'
      }
    >
      {copied ? (
        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
        </svg>
      ) : (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      )}
      {copied ? 'คัดลอกแล้ว!' : label}
    </button>
  )
}
